import service from '@/services/admin/event'

const getDefaultState = () => ({
  event: {}
})

export const state = () => getDefaultState()

export const mutations = {
  SET_EVENT: (state, event) => (state.event = event)
}

export const actions = {
  readByName: async ({ commit }, { name, groupName }) =>
    service.readByName(name, groupName).then(response => {
      commit('SET_EVENT', response)

      return response
    })
}
